// extracted by mini-css-extract-plugin
export default {"popover":"PopupPopover_popover__MHX19"};